import { render, staticRenderFns } from "./ResizeBlock.vue?vue&type=template&id=3524f224&"
import script from "./ResizeBlock.vue?vue&type=script&lang=js&"
export * from "./ResizeBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports